import { signupApi } from './signup'

import { AbTestParams, Participant } from 'types'

const abTestsApi = signupApi.injectEndpoints({
  endpoints: (builder) => ({
    abTests: builder.query<Participant[], AbTestParams>({
      query: ({ userKey, tests, participantId }) => {
        const encodeTests = tests.map((id) => `test=${encodeURIComponent(id)}`).join('&')
        return {
          url: `ab/participants/${participantId}?${encodeTests}&userKey=${userKey || participantId}`,
          method: 'GET',
        }
      },
    }),
  }),
})

const { useAbTestsQuery } = abTestsApi

export { abTestsApi, useAbTestsQuery }
